module.exports = __webpack_public_path__ + "img/symbol_0.15a9dfa5.png";